import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { FiArrowLeft } from "react-icons/fi";
import { IoIosArrowForward } from "react-icons/io";
import { getOemPartnerUsers } from "../../redux/actions/oemActions";
import UserDetailsTable from "./common/UserDetailsTable";
import "../../styles/InputSheet.css";

const OEMUserDetail = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();
  const partner = location.state?.partner;
  const { oemPartnerUsers: partnerUsers, oemPartnerUsersLoading: partnerUsersLoading, pagination: usersPagination } = useSelector(state => state.oem);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [statusFilter, setStatusFilter] = useState("active");
  const fetchUsers = (page = 1, search = "", status = "active") => {
    if (!partner?._id) return;
    
    dispatch(getOemPartnerUsers({
      oemId: partner._id,
      page,
      limit: 10,
      search,
      status
    }));
  };

  useEffect(() => {
    if (partner?._id) {
      fetchUsers(1, "", statusFilter);
    } else {
      navigate("/oem-partners");
    }
  }, [partner, navigate, statusFilter]);

  useEffect(() => {
    if (partner?._id) {
      fetchUsers(currentPage, searchTerm, statusFilter);
    }
  }, [currentPage, searchTerm, statusFilter, partner]);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    if (value.length === 0 || (value.length > 0 && value[0] !== " ")) {
      setSearchTerm(value);
      setCurrentPage(1);
    } else if (searchTerm.length > 0) {
      setSearchTerm(value);
      setCurrentPage(1);
    }
  };

  return (
    <div className="page-container">
      <div className="page-card scroll-container">
        <div className="form-header">
          <div className="d-flex align-items-center">
            <FiArrowLeft
              className="cursor-pointer me-3"
              style={{ fontSize: "1.5rem" }}
              onClick={() => navigate(-1)}
              title="Go Back"
            />
            <div className="d-flex align-items-center">
              {partner?.logo && (
                <img
                  src={partner.logo}
                  alt={partner.companyName}
                  className="me-3"
                  style={{
                    height: "40px",
                    width: "40px",
                    objectFit: "contain",
                    borderRadius: "8px",
                    border: "1px solid #ddd",
                  }}
                />
              )}
              <div>
                <h2 className="mb-0">
                  {partner?.companyName || "OEM Partner"}{" "}
                  <span className="text-secondary">
                    <IoIosArrowForward />
                  </span>
                  Users
                </h2>
                {partner && (
                  <small className="text-muted">{partner.email}</small>
                )}
              </div>
            </div>
          </div>
        </div>

        <UserDetailsTable
          users={partnerUsers}
          loading={partnerUsersLoading}
          currentPage={currentPage}
          pagination={usersPagination}
          searchTerm={searchTerm}
          statusFilter={statusFilter}
          handleSearchChange={handleSearchChange}
          setStatusFilter={setStatusFilter}
          setCurrentPage={setCurrentPage}
        />
      </div>
    </div>
  );
};

export default OEMUserDetail;
